module.exports = __webpack_public_path__ + "static/mobile-first-2fa58bf3f6538e60ecdc185b018a3631.png";